import { type Callback } from './EventEmitter';
import { IAnalyticsProvider } from './IAnalyticsProvider';

export abstract class AnalyticsProvider implements IAnalyticsProvider {
  abstract get name(): string;

  abstract init(callback: Callback): void;

  abstract authorize(userId: string, params?: Record<string, any>): void;

  abstract reset(): void;

  abstract trackEvent(eventName: string, eventProperties?: Record<string, any>, additionalProperties?: Record<string, any>): void;

  abstract trackPageVisit(pageTitle: string): void;

  abstract get initialized(): boolean;

  abstract mapAndExtendProperties(eventName: string, eventProperties?: Record<string, any>): Record<string, any>;
}
